import Modal from 'react-bootstrap/Modal';
import Image from 'react-bootstrap/Image';
import { useTranslation } from 'react-i18next';
import AwayterConnect from './../../utils/resources/awayter_connect_light_cropped.png'
import { useEffect } from 'react';
import { useSelector } from "react-redux";
import { selectUser } from '../../utils/redux/userSlice'
import packageJson from '../../../package.json';


const ModalAboutComponent = (props: { showModal: boolean, onHide: () => void }) => {
    const { t } = useTranslation();
    const user = useSelector(selectUser)
    //const dispatch = useDispatch();

    const appVersion = packageJson.version;
    //const [selectedCompany, setSelectedCompany] = useState<ISelectOptions>({ value: user.company?.idcompany, label: user.company?.name })
    //const [companyOptions, setCompanyOptions] = useState<ISelectOptions[]>([])
    //const [companies, setCompanies] = useState<Company[]>([])

    useEffect(() => {
        /*if (user.role === ROLES.Administrator) {
            const comp: ISelectOptions[] = []
            getAllCompanies(user.token)
                .then((json: Company[]) => {
                    setCompanies(json)
                    json.map((c) => comp.push({ value: c.idcompany, label: c.name }))
                })
                .catch((e) => console.log('Error GetAllCompanies', e))

            setCompanyOptions(comp)
        }*/
    }, [])

    const onChangeSelect = (e: any) => {
        /* setSelectedCompany(e)
         const company = companies.find((c: Company) => c.idcompany === e.value)
         if (company) {
             const userInfo = {
                 email: user.email,
                 user: user.user,
                 role: user.role,
                 iduser: user.iduser,
                 token: user.token,
                 auth: true,
                 company: company
             }
 
             dispatch(
                 login(userInfo)
             );
         }*/

    }


    return (
        <>
            <Modal show={props.showModal} onHide={props.onHide}>
                <Modal.Header className='position-relative' color='var(--text-primary)' style={{ backgroundColor: 'var(--background-secondary)', color: 'var(--text-primary)', borderColor: 'var(--background-secondary)' }}>
                    <div className='w-100 text-center'>
                        <p className="modal-title-custom m-0">{t('AboutApp')}</p>
                    </div>
                    <button type='button' className='btn-close position-absolute end-0 top-50 translate-middle-y me-3' aria-label='Close' onClick={props.onHide} style={{color: 'var(--text-primary)'}}> </button>
                </Modal.Header>
                <Modal.Body>
                    <div className='row mt-1'>
                        <div className='col'>
                            <span>{`${t('Version')}:`}</span>
                        </div>
                        <div className='col'>
                            <span>{`${appVersion}`}</span>
                        </div>
                    </div>
                    <div className='row mt-1'>
                        <div className='col'>
                            <span>{`${t('Powered By')}:`}</span>
                        </div>
                        <div className='col'>
                            <a href="https://www.awayter.com/" target="_blank" rel='noreferrer'>Awayter</a>
                        </div>
                    </div>
                    {/*user.role === ROLES.Administrator && <div className='row mt-1'>
                        <div className='col'>
                            <span>{`${t('Company')}:`}</span>
                        </div>
                        <div className='col'>
                            <Select closeMenuOnSelect={true} defaultValue={selectedCompany} onChange={onChangeSelect} options={companyOptions} />
    </div>
    </div>*/}
                    <div className='row mt-3'>
                        <div className='col text-center'>
                            <Image src={AwayterConnect} width={200} className='img-fluid' />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer></Modal.Footer>
            </Modal>
        </>
    )

}
export default ModalAboutComponent